import styled from 'styled-components';

export const NavigationButtons = styled.button`
  flex: 1;
  background: none;
  border: none;
`;

export const LabelContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.xxs};
`;
